import { useState } from "react";

type FAQItem = {
  q: string;
  a: string | JSX.Element;
};

const faqs: FAQItem[] = [
  {
    q: "どんな人が向いていますか？",
    a: "意志の力や薬でも一時的にやめられることはあります。ただ、長期で見ると続かないことがあります。YAMEBIは環境に介入するため、長期的に・安定して・我慢のストレスなく理想の習慣を続けたい方に向いています。",
  },
  {
    q: "どんな人には向いていないですか？",
    a: "「やめたい」という気持ちがそれほど強くない方には、設定や運用の手間を負担に感じる可能性があり、向いていない場合があります。",
  },
  {
    q: "意思が弱い私でもやめられますか？",
    a: "はい。YAMEBIは「我慢してやめる」のではなく、お菓子やジャンクフード、甘いものを買いにくい環境を作る仕組みです。意志力に頼らないため続けやすく、モニター試験でも90%の方が1ヶ月後もルールを継続しています。",
  },
  {
    q: "具体的にどんな仕組みで続けやすくなるのですか？",
    a: "YAMEBIは、クレジットカードやスマホ決済の購入情報をAIが確認し、お菓子・ジャンクフード・甘いものの購入を防ぐ仕組みです。例えばコンビニで「今日は少しだけ」と思ったときでも、購入段階でストップできる環境を作ります。つまり、我慢して続けるのではなく、環境で続く購入コントロールを実現します。※詳しい仕組みはLINEで説明しています。",
  },
  {
    q: "購入できない環境について、抜け道はありませんか？",
    a: "ご自身で行う購入については、基本的に抜け道はありません。例外として、同居人がお菓子を購入される等の場合は、抜け道となります。",
  },
  {
    q: "制限できる品目を教えてください",
    a: "お菓子やジャンクフードだけでなく、例えば、惣菜、コンビニ弁当、お肉などあらゆる飲食物が制限可能です。",
  },
  {
    q: "ストレスにならないですか？",
    a: "多くのユーザーから「むしろストレスが減った」という声をいただいています。YAMEBIは、週2日はOK・1日1回までOKなど、ルールを柔軟に設定できます。さらに、そもそも買えない環境を作る仕組みのため、我慢や自己嫌悪のストレスが生まれにくいのが特徴です。",
  },
  {
    q: "普段の生活に支障は出ないですか？",
    a: "基本的には問題ありません。YAMEBIは制限する対象を自由に設定できます。コンビニのみ・スーパーのみなど、店舗単位の設定も可能です。さらに、時間帯・曜日・週あたりの回数なども設定できるため、生活に合わせて無理なく調整できます。",
  },
  {
    q: "家族用の買い物も制限されますか？",
    a: "ご家族のための買い物については、制限の対象外として設定することも可能です。詳しくは、LINEでAIにご質問ください。",
  },
  {
    q: "外食や付き合いで食べることがある場合はどうすればいいですか？",
    a: "YAMEBIは、外食や人付き合い自体を禁止するサービスではありません。例えば、夜のコンビニだけ制限・デリバリーだけ制限といった細かい設定が可能です。そのため、必要な場面は残しながら、衝動的な購入だけ防ぐことができます。",
  },
  {
    q: "外食も制限対象にできますか？",
    a: "はい、可能です。",
  },
  {
    q: "個人情報や決済情報は安全ですか？",
    a: "はい、安全に管理されています。YAMEBIでは、ユーザー名や購入情報などの個人情報をすべて暗号化して管理しています。そのため、運用者を含め第三者が内容を閲覧できない仕組みになっています。また、セキュリティ面についても十分な対策を実施し、ユーザー情報の保護に配慮しています。※セキュリティの仕組みやポリシーの詳細は、LINEにてご確認いただけます。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm text-[#B07040] font-bold tracking-widest uppercase mb-3">FAQ</p>
          <h2 className="text-2xl md:text-3xl font-black text-[#1a1a1a]">よくあるご質問</h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-gray-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="font-bold text-[#1a1a1a] text-sm md:text-base">{faq.q}</span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIndex === i ? "subtract" : "add"}-line text-lg text-[#888] transition-transform`}></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-6 py-5 bg-white border-t border-gray-100">
                  <p className="text-[#555] text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
